// removed by extract-text-webpack-plugin
module.exports = {"statement":"Statement__statement___3YjHF","statement-with-drop-cap":"Statement__statement-with-drop-cap___1ECMR Statement__statement___3YjHF","statement-with-columns":"Statement__statement-with-columns___31oh3 Statement__statement___3YjHF","enable-with-columns-and-dropcap":"Statement__enable-with-columns-and-dropcap___VfNsZ Statement__statement-with-columns___31oh3 Statement__statement___3YjHF Statement__statement-with-drop-cap___1ECMR Statement__statement___3YjHF"};


//////////////////
// WEBPACK FOOTER
// ./application/js/components/Statement.css
// module id = 523
// module chunks = 0